import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { SearchConfig } from "@/components/dynamic-form";
import { SearchBarType } from "@/components/dynamic-form/constants";
import queryString from "query-string";
import dayjs from "dayjs";

export function getSearchConfig(): SearchConfig[] {
  const t = getTranslateNsT("consumption");
  const searchParams = queryString.parse(window.location.search);
  const startTime = Number(searchParams.billStartTime);
  let monentStart = new Date(
    new Date().getFullYear(),
    new Date().getMonth() - 3,
    1
  );
  let monentEnd = new Date(
    new Date().getFullYear(),
    new Date().getMonth() - 1,
    1
  );
  if (startTime) {
    monentStart = new Date(
      new Date(startTime).getFullYear(),
      new Date(startTime).getMonth(),
      1
    );
    monentEnd = new Date(
      new Date(startTime).getFullYear(),
      new Date(startTime).getMonth(),
      1
    );
  }
  return [
    {
      type: SearchBarType.DatePicker,
      field: "time",
      label: t("consumption_time_selector"),
      limitMonthNum: 12,
      isTrendsChangeDate: true,
      props: {
        picker: "month",
        allowClear: false,
        defaultValue: [dayjs(monentStart), dayjs(monentEnd)],
      },
    },
    {
      type: SearchBarType.Input,
      label: t("consumption_label_bill_no"),
      field: "billNo",
      props: {
        placeholder: t("consumption_bill_no_placeholder"),
      },
    },
    {
      type: SearchBarType.Select,
      field: "payStatus",
      label: t("consumption_label_pay_status"),
      props: {
        placeholder: t("consume_pick_platform_all"),
        allowClear: true,
        options: [
          {
            label: t("consumption_pay_status_0"),
            value: 0,
          },
          {
            label: t("consumption_pay_status_1"),
            value: 1,
          },
        ],
      },
    },
    {
      type: SearchBarType.Input,
      label: t("consumption_table_header_company"),
      field: "company",
      props: {
        placeholder: t("consumption_company_placeholer"),
      },
    },
    {
      type: SearchBarType.Select,
      field: "confirmStatus",
      label: t("consumption_label_confirm_status"),
      props: {
        placeholder: t("consume_pick_platform_all"),
        allowClear: true,
        options: [
          {
            label: t("bill_confirm_status_0"),
            value: 0,
          },
          {
            label: t("bill_confirm_status_1"),
            value: 1,
          },
          {
            label: t("bill_confirm_status_2"),
            value: 2,
          },
        ],
      },
    },
  ];
}
